import { HTTP_TOKEN } from "./http";

export const getPagesIgnore = params => {
  return HTTP_TOKEN.get("page-ignore", { params }).then(result => {
    return result.data;
  });
};

export const createPageIgnore = data => {
  return HTTP_TOKEN.post("page-ignore", data).then(result => {
    return result.data;
  });
};


export const deletePageIgnore = (pageId) => {
  return HTTP_TOKEN.delete(`page-ignore/${pageId}`).then(result => {
    return result.data;
  });
};


export const updatePageIgnore = (pageId, data) => {
  return HTTP_TOKEN.put(`page-ignore/${pageId}`, data).then(result => {
    return result.data;
  });
};
